var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderOpenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7701 4.5H6.39258C5.56758 4.5 4.89258 5.175 4.89258 6V18C4.89258 18.825 5.56758 19.5 6.39258 19.5H13.1426V15C13.1426 14.175 13.8176 13.5 14.6426 13.5H16.8926V9.6225C16.8926 9.225 16.7351 8.8425 16.4501 8.565L12.8276 4.9425C12.5501 4.6575 12.1676 4.5 11.7701 4.5ZM11.6426 9V5.625L15.7676 9.75H12.3926C11.9801 9.75 11.6426 9.4125 11.6426 9ZM18.8876 15.75C18.8876 16.1625 18.5501 16.5 18.1376 16.5H17.2076L18.8876 18.18C19.1801 18.4725 19.1801 18.945 18.8876 19.2375C18.5951 19.53 18.1226 19.53 17.8301 19.2375L16.1426 17.5575V18.4875C16.1426 18.9 15.8051 19.2375 15.3926 19.2375C14.9801 19.2375 14.6426 18.9 14.6426 18.4875V15.75C14.6426 15.3375 14.9801 15 15.3926 15H18.1376C18.5501 15 18.8876 15.3375 18.8876 15.75Z",
    fill: "#002D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpenIcon);
export default __webpack_public_path__ + "static/media/folder_open_icon.6d8e128f2d79f0d98d36d01203f4a89a.svg";
export { ForwardRef as ReactComponent };